import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CameraComponent } from '@app/shared/camera/camera.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [CameraComponent],
  imports: [CommonModule, MatProgressBarModule, MatIconModule, MatButtonModule],
  exports: [CameraComponent],
})
export class CameraModule {}
